<template>
  <div>
    <v-row justify="center">
      <v-dialog
          v-model="dialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
          @keydown.esc="avisoCerrar"
          persistent
        >
          <v-card tile>
            <v-toolbar
              flat
              dark
              color="primary"
            >
              <v-btn
                icon
                dark
                @click="avisoCerrar"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>
                <span v-if="!editandoGrupo && !grupo.nombreGrupo">
                  Nuevo Grupo
                </span>
                <span>
                  {{ grupo.nombreGrupo }}
                </span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  dark
                  text
                  @click="guardar"
                  :disabled="this.$v.grupo.$invalid"
                >
                  Guardar
                </v-btn>
              </v-toolbar-items>
              <v-menu
                bottom
                right
                offset-y
              >
              </v-menu>
            </v-toolbar>
            <v-card-text>
              <v-expansion-panels
                v-model="panel"
                multiple
              >
                <v-expansion-panel class="mt-4">
                  <v-expansion-panel-header class="text-h6">Información Básica</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" class="pt-0 pb-0">
                          <v-text-field
                              v-model="grupo.nombreGrupo"
                              :disabled="grupo.grupoSistema"
                              label="Nombre"
                              prepend-icon="mdi-account-multiple-outline"
                              required
                              :error-messages="errorNombre"
                              @input="$v.grupo.nombreGrupo.$touch()"
                              @blur="$v.grupo.nombreGrupo.$touch()"
                              class="anadirAsterisco"
                            ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="pt-0 pb-0">
                        <v-textarea
                          prepend-icon="mdi-note-text-outline"
                          label="Observaciones"
                          v-model="grupo.observaciones"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                    
                <v-expansion-panel>
                  <v-expansion-panel-header class="text-h6">Usuarios</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <dialogAddUsersToGroup class="mr-4"/>
                    <tabla-usuarios-grupo/>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header class="text-h6">Permisos</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <permisos-grupo/>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header class="text-h6">Configuración</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12">
                        <p class="font-weight-medium">
                          Aquí puedes habilitar o deshabilitar el grupo para impedir su acceso a la aplicación.
                        </p>
                        <v-alert
                          dense
                          outlined
                          border="left"
                          type="warning"
                          icon="mdi-alert-outline"
                          v-if="grupo.grupoSistema"
                        >
                          Los grupos de sistema no pueden ser deshabilitados
                        </v-alert>
                        <v-btn
                          color="warning"
                          class="ma-2"
                          outlined
                          :disabled="grupo.grupoSistema"
                          v-if="grupo.habilitado"
                          @click="grupo.habilitado = 0"
                        >
                        <v-icon
                            left
                            dark
                          >
                            mdi-cancel
                          </v-icon>
                          Deshabilitar
                        </v-btn>
                        <v-btn
                          color="success"
                          class="ma-2"
                          outlined
                          v-else
                          @click="grupo.habilitado = 1"
                        >
                        <v-icon
                            left
                            dark
                          >
                            mdi-account-multiple-check-outline
                          </v-icon>
                          Habilitar
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-divider class="mb-4"></v-divider>
                    <v-row>
                      <v-col cols="12">
                          <p class="font-weight-medium">
                              Puedes indicar a continuación las IPs autorizadas para acceder a la aplicación.
                          </p>
                          <p>Nota: * indica que el usuario puede acceder desde cualquier red.</p>
                          <v-textarea
                          prepend-icon="mdi-ip-network-outline"
                          label="IPs permitidas"
                          hint="Puedes añadir varias IPs separándolas por comas"
                          v-model="grupo.IpsConfianza"
                          @input="$v.grupo.IpsConfianza.$touch()"
                          @blur="$v.grupo.IpsConfianza.$touch()"
                          :error-messages="errorIpsConfianza"
                          class="anadirAsterisco"
                          ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-if="editandoGrupo">
                  <v-expansion-panel-header class="text-h6">Metadata</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12">
                        <p class="font-weight-bold d-inline">Última modificación:</p> {{ formatearFecha(grupo.updated_at) }} por {{ usuarios[getPosicionIdUsuario(grupo.idUsuarioModificacion)].nombre }} {{ usuarios[getPosicionIdUsuario(grupo.idUsuarioModificacion)].apellidos }}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <p class="font-weight-bold d-inline">Fecha de creación:</p> {{ formatearFecha(grupo.created_at) }} por {{ usuarios[getPosicionIdUsuario(grupo.idUsuarioCreacion)].nombre }} {{ usuarios[getPosicionIdUsuario(grupo.idUsuarioCreacion)].apellidos }}
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
          </v-card>
        </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogCerrar" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">¡Atención!</v-card-title>
          <v-card-text>Vas a salir sin guardar los cambios. ¿Estás seguro?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogCerrar = false">Cancelar</v-btn>
            <v-btn color="error" text @click="cerrar">Salir</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
  
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import axios from 'axios';
  import chunk from 'chunk';
  import DialogAddUsersToGroup from './DialogAddUsersToGroup';
  import TablaUsuariosGrupo from './TablaUsuariosGrupo';
  import PermisosGrupo from './PermisosGrupo';
  import formatearFecha from '../../mixins/formatearFecha';
  import { required } from 'vuelidate/lib/validators';
  export default {
    name: 'FullDialogGrupo',
    mixins: [formatearFecha],
    data () {
      return {
        dialogCerrar: false,
        buscarUsuariosGrupo: '',
        panel: [0, 4],
        items: 4,
        headersUsuariosGrupo: [
          {
            text: 'Nombre',
            align: 'start',
            filterable: true,
            sortable: true,
            value: 'name'
          },
          {
            text: 'Apellidos',
            filterable: true,
            sortable: true,
            value: 'apellidos',
          },
          {
            text: 'Email',
            filterable: true,
            sortable: true,
            value: 'email'
          },
          {
            text: '',
            filterable: false,
            sortable: false,
            value: 'acciones'
          }
        ]
      }
    },
    validations: {
      grupo: {
        nombreGrupo: {required},
        IpsConfianza: {required}
      }
    },
    methods: {
      ...mapActions('grupos', ['setDialog','setGrupos']),
      ...mapActions(['setLoading', 'setSnackbar']),
      avisoCerrar(){
        this.dialogCerrar = true;
      },
      cerrar(){
        this.dialogCerrar = false;
        this.setDialog(false);
      },
      guardar(){
        this.setLoading(true);
        // console.log(this.grupo);
        if(this.editandoGrupo){
          axios.patch("/api/grupos", this.grupo).then(respuesta => {
            axios.get("/api/grupos").then(respuesta => {
              console.log(respuesta);
              this.setGrupos(respuesta);
            }).catch(error =>{
                console.log(error);
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'No se han podido recuperar los grupos'
                });
            });
            console.log(respuesta);
            this.setLoading(false);
            this.setSnackbar({
                tipo: 'success',
                mensaje: 'Datos guardados correctamente'
            });
            this.setDialog(false);
          }).catch(error =>{
            //console.log(error);
            this.setLoading(false);
            this.setSnackbar({
                tipo: 'error',
                mensaje: 'Error. No se han podido guardar los datos'
            });
          });
        }else{
          axios.post("api/grupos", this.grupo).then(respuesta => {
            this.setLoading(false);
            axios.get("/api/grupos").then(respuesta => {
              this.setGrupos(respuesta);
              this.setDialog(false);
              this.setSnackbar({
                tipo: 'success',
                mensaje: 'Grupo creado correctamente'
              });
              this.setDialog(false);
            }).catch(error =>{
              this.setSnackbar({
                  tipo: 'error',
                  mensaje: 'No se han podido recuperar los grupos'
              });
            });
            // console.log(respuesta);
          }).catch(error => {
            // console.log(error);
            this.setLoading(false);
            this.setSnackbar({
                tipo: 'error',
                mensaje: 'Error. No se ha podido crear el grupo'
            })
          });
        }
        
      },
      eliminarUsuario(usuario){
        let indiceElemento = this.grupo.user.indexOf(usuario);
        this.grupo.user.splice(indiceElemento, 1);
      },
      getPosicionIdUsuario(id){
        //Devuelve la posición del array usuarios del id Usuario que se le pasa
        return this.usuarios.findIndex(x => x.id === id);
      }
    },
    computed: {
      ...mapState('grupos', ['dialog', 'grupo', 'grupos', 'editandoGrupo']),
      ...mapState('usuarios', ['usuarios']),
      errorNombre () {
        if (this.$v.grupo.nombreGrupo.$dirty){
          if (this.$v.grupo.nombreGrupo.$invalid){
            return 'Introduce el nombre del grupo';
          }
        }
      },
      errorIpsConfianza () {
        if (this.$v.grupo.IpsConfianza.$dirty){
          if (!this.$v.grupo.IpsConfianza.required){
            return 'Indica una IP o un * para permitir el acceso desde cualquier red';
          }
        }
      },
    },
    created(){
      if (this.editandoGrupo){
        this.panel = [0, 4];
      }else{
        this.panel = [...Array(this.items).keys()].map((k, i) => i);
      }
    },
    components: {
      'dialogAddUsersToGroup': DialogAddUsersToGroup,
      'tabla-usuarios-grupo': TablaUsuariosGrupo,
      'permisos-grupo': PermisosGrupo
    }
  }
</script>